import request from "@/utiles/axios";
export function selectAllByPage(data) {
    return request({
      url: "/pc/task/selectAllByPage",
      method: "post",
      data: data,
    });
  }
  export function downloadExcel(data) {
    return request({
      url: "/pc/task/downloadExcel",
      method: "post",
      data: data,
    });
  }
  